document.addEventListener("DOMContentLoaded", function () {
    // FAQ toggle
    const questionsBlocks = document.querySelectorAll(".questions");

    questionsBlocks.forEach((questionsDiv, index) => {
        const operator = questionsDiv.querySelector("#operator");
        const reponseDiv = questionsDiv.querySelector(".reponse");

        questionsDiv.addEventListener("click", function () {
            const isActive = questionsDiv.classList.contains("active");
            questionsDiv.classList.toggle("active");
            operator.textContent = isActive ? "+" : "-";

            if (!isActive) {
                reponseDiv.style.maxHeight = reponseDiv.scrollHeight + "px";

                reponseDiv.addEventListener(
                    "transitionend",
                    function callback() {
                        if (questionsDiv.classList.contains("active")) {
                            reponseDiv.style.maxHeight = "none";
                        }
                        reponseDiv.removeEventListener(
                            "transitionend",
                            callback
                        );
                    }
                );
            } else {
                reponseDiv.style.maxHeight = reponseDiv.scrollHeight + "px";
                requestAnimationFrame(() => {
                    reponseDiv.style.maxHeight = "0";
                });
            }
        });

        // Ouvre automatiquement la première
        if (index === 0) {
            questionsDiv.classList.add("active");
            operator.textContent = "-";
            reponseDiv.style.maxHeight = "none";
        }
    });

    // Navigation active toggle
    const navigationItems = document.querySelectorAll(".navigation-item");

    navigationItems.forEach((navigationItem) => {
        navigationItem.addEventListener("click", function () {
            navigationItems.forEach((item) => item.classList.remove("active"));
            this.classList.add("active");
        });
    });

    // Voir plus d'articles (AJAX)
    const btn = document.getElementById("load-more-articles");

    if (btn) {
        btn.addEventListener("click", function () {
            fetch(ajax_data.ajaxurl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "load_all_articles",
                    exclude: btn.dataset.exclude,
                }),
            })
                .then((res) => res.text())
                .then((html) => {
                    document.querySelector(".articles").innerHTML += html;
                    btn.remove(); // Supprimer le bouton après affichage
                });
        });
    }

    // Parallax effet sur les images
    document.querySelectorAll(".parallax-container").forEach((container) => {
        const img = container.querySelector("img");
        const movement = 10;

        container.addEventListener("mousemove", (e) => {
            const rect = container.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width - 0.5;
            const y = (e.clientY - rect.top) / rect.height - 0.5;

            const translateX = x * movement;
            const translateY = y * movement;

            img.style.transform = `translate(${translateX}px, ${translateY}px)`;
        });

        container.addEventListener("mouseleave", () => {
            img.style.transform = "translate(0, 0)";
        });
    });
});
